export const ONBOARDING_V1_PROJECTION_PRINCIPAL_USD = 10_000;
export const ONBOARDING_V1_PROJECTION_YEARS = 10;

export const ONBOARDING_V1_PROJECTION_ANNUAL_RATES = {
  glider: 0.12,
  highYieldSavings: 0.04,
  otherInvestingApps: 0.08,
} as const;

export interface OnboardingV1ProjectionPoint {
  readonly glider: number;
  readonly highYieldSavings: number;
  readonly otherInvestingApps: number;
  readonly year: number;
}

export interface OnboardingV1ProjectionModel {
  readonly points: readonly OnboardingV1ProjectionPoint[];
  readonly principalUsd: number;
  readonly years: number;
}

function calculateFutureValue(annualRate: number, year: number): number {
  return ONBOARDING_V1_PROJECTION_PRINCIPAL_USD * (1 + annualRate) ** year;
}

export function createOnboardingV1Projection(): OnboardingV1ProjectionModel {
  return {
    points: Array.from(
      { length: ONBOARDING_V1_PROJECTION_YEARS + 1 },
      (_, year) => ({
        glider: calculateFutureValue(
          ONBOARDING_V1_PROJECTION_ANNUAL_RATES.glider,
          year,
        ),
        highYieldSavings: calculateFutureValue(
          ONBOARDING_V1_PROJECTION_ANNUAL_RATES.highYieldSavings,
          year,
        ),
        otherInvestingApps: calculateFutureValue(
          ONBOARDING_V1_PROJECTION_ANNUAL_RATES.otherInvestingApps,
          year,
        ),
        year,
      }),
    ),
    principalUsd: ONBOARDING_V1_PROJECTION_PRINCIPAL_USD,
    years: ONBOARDING_V1_PROJECTION_YEARS,
  };
}
